<template>
  <div class="app-layout">
    <Sidebar
      :is-authenticated="isAuthenticated"
      @logout="handleLogout"
      @login="showLoginModal = true"
    />

    <main class="main-content">
      <router-view @login="showLoginModal = true" />
    </main>

    <LoginModal
      :visible="showLoginModal"
      @close="showLoginModal = false"
      @success="onLoginSuccess"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { getToken, clearAuth } from "./services/auth";
import Sidebar from "./components/common/Sidebar.vue";
import LoginModal from "./components/common/LoginModal.vue";

export default defineComponent({
  name: "App",
  components: { Sidebar, LoginModal },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const isAuthenticated = ref(!!getToken());
    const showLoginModal = ref(false);

    // On non-home pages, if not authenticated, show login modal
    watch([isAuthenticated, () => route.path], ([auth, path]) => {
      if (!auth && path !== "/") {
        showLoginModal.value = true;
      } else {
        showLoginModal.value = false;
      }
    }, { immediate: true });

    const handleLogout = () => {
      clearAuth();
      isAuthenticated.value = false;
      router.push("/");
    };

    const onLoginSuccess = () => {
      isAuthenticated.value = true;
      showLoginModal.value = false;
      router.push("/workflows");
    };

    return {
      isAuthenticated,
      showLoginModal,
      handleLogout,
      onLoginSuccess,
    };
  },
});
</script>

<style lang="less">
@import "./assets/styles/variables.less";

html, body {
  min-width: 800px;
}

.app-layout {
  min-height: 100vh;
  display: flex;
}

.main-content {
  flex: 1;
  margin-left: @sidebar-width;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 900px;
  background: #f1f1f1;
}
</style>
